import { render, staticRenderFns } from "./wait.vue?vue&type=template&id=61d2dc86&scoped=true"
import script from "./wait.vue?vue&type=script&lang=js"
export * from "./wait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d2dc86",
  null
  
)

export default component.exports